import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Building2 } from "lucide-react";
import { toast } from "sonner";

export const EMPLOYER_CONTEXTS = [
  ["unspecified", "Employer type: not set"],
  ["federal", "Federal agency"],
  ["private", "Private / nonprofit employer"],
  ["state_local", "State or local government"],
];

// Employer context (saved preference). Federal-sector samples and framing appear only when "Federal agency" is selected.
export default function EmployerContextSelector() {
  const { user, setUser } = useAuth();
  const change = async (v) => {
    try { const { data } = await api.patch("/auth/preferences", { employer_context: v }); setUser(data); toast.success(EMPLOYER_CONTEXTS.find((c) => c[0] === v)?.[1]); }
    catch { toast.error("Could not save employer type"); }
  };
  return (
    <div className="inline-flex items-center gap-1.5" data-testid="employer-context-selector">
      <Building2 className="w-3.5 h-3.5 text-[#C7761A]" />
      <Select value={user?.employer_context || "unspecified"} onValueChange={change}>
        <SelectTrigger data-testid="employer-context-trigger" className="h-8 w-auto min-w-[10rem] text-xs border-slate-300 bg-white gap-2"><SelectValue /></SelectTrigger>
        <SelectContent>
          {EMPLOYER_CONTEXTS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`employer-context-${v}`}>{l}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
